export default {
    butter: {
        name: 'Butter',
        liquid: false,
        density: {mass: 'g',volume:'cm3',density:0.911},
        efficiency: 0.93
    },
    coconutoil: {
        name: 'Coconut Oil',
        liquid: false,
        density: {mass: 'g',volume:'cm3',density:0.903},
        efficiency: 0.93
    },
    oiliveoil: {
        name: 'Olive Oil',
        liquid: true,
        density: {mass: 'kg',volume:'l',density:0.916},
        efficiency: 0.96
    },
    mctoil: {
        name: 'MCT Oil',
        liquid: true,
        density: {mass: 'g',volume:'cm3',density:0.95},
        efficiency: 0.91
    },
    alcohol: {
        name: 'Alcohol',
        liquid: true,
        density: {mass: 'g',volume:'cm3',density:0.789},
        efficiency: 0.90
    },
    walnutoil: {
        name: 'Walnut Oil',
        liquid: true,
        density: {mass: 'g',volume:'cm3',density:0.924},
        efficiency: 0.83
    },
    avocadooil: {
        name: 'Avocado Oil',
        liquid: true,
        density: {mass: 'g',volume:'ml',density:0.920},
        efficiency: 0.92
    },
    grapeseedoil: {
        name: 'Grapeseed Oil',
        liquid: true,
        density: {mass: 'g',volume:'cm3',density:0.920},
        efficiency: 0.81
    }
}